import React, {Component} from 'react'
import PropTypes from "prop-types";
import '../../components_style/rtl_css/FormElementContainer.css'
import '../../components_style/FormElementContainer.css'
import SvGraphics from "../../assets/SvGraphics";
import ClinicEditForm from "../clinic/ClinicEditForm";

class FormElementContainerExpandedPatientPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded:this.props.isExpanded,
        };
    }


    onClickArrow= ()=> {
        this.setState({isExpanded: !this.state.isExpanded})
    }


    render() {
        let {isExpanded}=this.state
        let {title,Component,rest,isSub,subTitle,svgName,t} = this.props
        let displaySVG='none'
        let titleClass='patientsPageFormBoxes-title-text-label2'
        if(svgName!=='' && subTitle!==''){
            displaySVG='flex'
            titleClass='patientsPageFormBoxes-title-text-label'
        }
        rest = {...rest,isExpanded,closeSideBar:()=>this.closeSideBar()}
        return (
            <div  className={'patientForm-box-container-PatientPage'}>
                { {title}!=='' ?
                    <div className={'patientsFormBoxes-title-text2'} style={{display:'flex'}}>
                        <label className={titleClass}> {title}</label>
                        <div style={{display:displaySVG, margin:'0 30px',minWidth:'146px', cursor:'pointer'}}>
                            <SvGraphics svgname={svgName} style={{height:'13px',width:'13px',margin:'4px 4px 4px 4px'}}/>
                            <div className={'patientsFormBoxes-title-text-label-edit'} onClick={()=>this.props.openSideBar()}>{subTitle}</div>
                        </div>
                        <SvGraphics className={!isExpanded?"patient-onboard-arrow":"patient-onboard-arrow-rotate"}
                                    style={{height:'22px',width:'22px'}} svgname={'arrow-down'} onClick={()=>this.onClickArrow()}/>
                    </div>
                    : ""}
                <Component {...rest} />
            </div>

        )
    }
}

FormElementContainerExpandedPatientPage.propTypes = {
    title: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired,
    rest: PropTypes.object
};

export default FormElementContainerExpandedPatientPage;
